export default __webpack_public_path__ + "static/tailwind-css-2d2897b770bb2f52c841cbd5e28d5ea6.png";